import { Search, History } from "history";
import pretty from "Shared/pretty";
import { RewardStatus } from "Shared/types/Rewards";

export interface RewardsQueryProps {
  page: number;
  beginDate?: string | null;
  endDate?: string | null;
  rewarderId?: string | null;
  status?: RewardStatus;
}

const formatDateParam = (dateString: string | null) => {
  return dateString
    ? pretty.date(dateString, { format: "YYYY-MM-DD"})
    : null;
};


export function queryParamsToProps(search: Search) {
  const searchParams = new URLSearchParams(search);
  const pageParam = searchParams.get("page");
  const page = pageParam ? +pageParam : 1;
  const beginDateParam = searchParams.get("beginDate");
  const beginDate = formatDateParam(beginDateParam);
  const endDateParam = searchParams.get("endDate");
  const endDate = formatDateParam(endDateParam);
  const rewarderId = searchParams.get("rewarder");
  const status = searchParams.get("status") as RewardStatus;

  return {
    page,
    beginDate,
    endDate,
    rewarderId,
    status,
  };
}

export function propsToQueryParams(props: RewardsQueryProps) {
  let queryString = `?page=${props.page}`;
  if (props.beginDate) {
    queryString += `&beginDate=${formatDateParam(props.beginDate)}`;
  }
  if (props.endDate) {
    queryString += `&endDate=${formatDateParam(props.endDate)}`;
  }
  if (props.rewarderId) {
    queryString += `&rewarder=${props.rewarderId}`;
  }
  if (props.status) {
    queryString += `&status=${props.status}`;
  }

  return queryString;
}

export const goToReportPage = (history: History, queryProps: RewardsQueryProps) => {
  history.push(`${propsToQueryParams(queryProps)}`);
};
